module.exports = __webpack_public_path__ + "img/major7.940d1624.png";